// Calendar Block Component
// Displays class schedule calendar
import React, { useState, useEffect } from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import api from '../../services/api';

const CalendarBlock = ({ content, padding, backgroundColor, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showMonths, setShowMonths] = useState(content?.showMonths || 3);
  const [highlightEvents, setHighlightEvents] = useState(content?.highlightEvents !== false);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const response = await api.get('/classes');
      setClasses(response.classes || []);
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  const handleSave = () => {
    onUpdate({
      content: {
        showMonths,
        highlightEvents
      }
    });
    setIsEditing(false);
  };

  const getPaddingClass = () => {
    switch (padding) {
      case 'none': return 'p-0';
      case 'small': return 'p-4';
      case 'large': return 'p-12';
      default: return 'p-8';
    }
  };

  if (isEditing) {
    return (
      <div className={getPaddingClass()} style={{ backgroundColor }}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#3C3C3C] dark:text-gray-100 mb-2">
              Number of Months to Show
            </label>
            <input
              type="number"
              min="1"
              max="12"
              value={showMonths}
              onChange={(e) => setShowMonths(parseInt(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-[#3C3C3C] dark:text-gray-100"
            />
          </div>

          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={highlightEvents}
                onChange={(e) => setHighlightEvents(e.target.checked)}
                className="rounded border-gray-300 dark:border-gray-600"
              />
              <span className="text-sm text-[#3C3C3C] dark:text-gray-100">
                Highlight upcoming events
              </span>
            </label>
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-[#7A99D8] text-white rounded hover:bg-[#6A89C8]"
            >
              Save
            </button>
            <button
              onClick={() => {
                setShowMonths(content?.showMonths || 3);
                setHighlightEvents(content?.highlightEvents !== false);
                setIsEditing(false);
              }}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded text-[#3C3C3C] dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={getPaddingClass()}
      style={{ backgroundColor }}
    >
      <div className="text-center">
        <CalendarIcon className="w-12 h-12 text-[#7A99D8] mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-[#3C3C3C] dark:text-gray-100 mb-2">
          Class Schedule Calendar
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Showing {showMonths} {showMonths === 1 ? 'month' : 'months'} of upcoming classes
        </p>
      </div>
    </div>
  );
};

export default CalendarBlock;
